import axios from "axios";

const normalizeApiBaseUrl = () => {
  const rawBaseUrl = (process.env.REACT_APP_URL_API || "").trim();

  if (!rawBaseUrl) {
    return "";
  }

  if (
    typeof window !== "undefined" &&
    window.location.protocol === "https:" &&
    rawBaseUrl.startsWith("http://")
  ) {
    return rawBaseUrl.replace(/^http:\/\//i, "https://");
  }

  return rawBaseUrl;
};

export const avantSolarApi = axios.create({
  baseURL: normalizeApiBaseUrl(),
});
